export const POST_SIGN_IN_REQUEST = 'signin/POST_SIGN_IN_REQUEST';
export const POST_SIGN_IN_SUCCESS = 'signin/POST_SIGN_IN_SUCCESS';
export const POST_SIGN_IN_FAILURE = 'signin/POST_SIGN_IN_FAILURE';

export const ON_CHANGE_EMAIL = 'signin/ON_CHANGE_EMAIL';
export const ON_CHANGE_PASSWORD = 'signin/ON_CHANGE_PASSWORD';
